// Three-arm preferences entrypoint experiment: control vs nature imagery vs animated text header
export enum CustomPreferencesExperimentRoundThreeVariation {
  CONTROL = 'control',
  NATURE_IMAGERY = 'natureImagery',
  ANIMATED_TEXT_HEADER = 'animatedTextHeader',
}
